module.exports = __webpack_public_path__ + "static/media/fig.6ee5de1d.png";